<template lang="pug">
.layout
  BriqToolbar
  .workspace
    BriqNavbar(:boldLinks="boldLinks" :normalLinks="normalLinks")
    .content
      slot
  BriqIconDefs
</template>

<script>
import BriqNavbar from './layout/BriqNavbar.vue'
import BriqToolbar from './layout/BriqToolbar.vue'

export default {
  name: 'BriqLayout',
  components: { BriqNavbar, BriqToolbar },
  props: {
    boldLinks: Array,
    normalLinks: Array,
  },
}
</script>

<style scoped lang="stylus">
.layout
  padding-left 70px
  height 100%

.workspace // includes navbar and content
  height 100%
  display flex
  flex-direction column
  flex-grow 1

.content
  height 100%
</style>
